/**
 * Delivery info date calculator + modal toggle.
 * Config injected via data attributes on [data-ht-delivery].
 */
(function () {
  const root = document.querySelector('[data-ht-delivery]');
  if (!root) return;

  const prodMin = parseInt(root.dataset.prodMin, 10) || 3;
  const prodMax = parseInt(root.dataset.prodMax, 10) || 5;
  const shipMin = parseInt(root.dataset.shipMin, 10) || 7;
  const shipMax = parseInt(root.dataset.shipMax, 10) || 10;

  function addBusinessDays(start, days) {
    const d = new Date(start);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) added++;
    }
    return d;
  }

  function fmtDate(d) {
    return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
  }

  function fmtRange(d1, d2) {
    var m1 = d1.toLocaleDateString('en-US', { month: 'long' });
    var m2 = d2.toLocaleDateString('en-US', { month: 'long' });
    if (m1 === m2) return m1 + ' ' + d1.getDate() + '–' + d2.getDate();
    return fmtDate(d1) + ' – ' + fmtDate(d2);
  }

  var today = new Date();
  var shipStart = addBusinessDays(today, prodMin);
  var shipEnd = addBusinessDays(today, prodMax);
  var deliverStart = addBusinessDays(today, prodMin + shipMin);
  var deliverEnd = addBusinessDays(today, prodMax + shipMax);

  var dateEl = root.querySelector('[data-delivery-date]');
  if (dateEl) dateEl.textContent = fmtRange(deliverStart, deliverEnd);

  var orderDateEl = root.querySelector('[data-timeline-order]');
  if (orderDateEl) orderDateEl.textContent = 'Today, ' + fmtDate(today);

  var shipDateEl = root.querySelector('[data-timeline-ship]');
  if (shipDateEl) shipDateEl.textContent = fmtRange(shipStart, shipEnd);

  var deliverDateEl = root.querySelector('[data-timeline-deliver]');
  if (deliverDateEl) deliverDateEl.textContent = fmtRange(deliverStart, deliverEnd);

  // Modal toggle
  var overlay = root.querySelector('.ht-delivery__modal-overlay');
  if (!overlay) return;

  function open() { overlay.classList.add('is-open'); }
  function close() { overlay.classList.remove('is-open'); }

  if (dateEl) {
    dateEl.addEventListener('click', open);
    dateEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
    });
  }

  var closeBtn = overlay.querySelector('.ht-delivery__modal-close');
  if (closeBtn) closeBtn.addEventListener('click', close);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
  });
})();
